<template>
  <div class="home">Bạn đang cố gắng truy cập trang không được cấp quyền, vui lòng đăng nhập lại</div>
</template>
<style>
 .p-datatable {
   font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
   font-size: 13px!important;
 }
 .p-inputtext {
  font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
  font-size: 13px!important;
 }
 .p-component {
  font-family: "Open Sans", "Helvetica Neue", sans-serif!important;
  font-size: 13px!important; 
 }
 /* .p-dialog-header-close-icon {
   display: none!important;
 } */
</style>
<script>
import $ from 'jquery'
export default {
  name: 'Home',
  created() {
    if (this.$route.params.reload === 1) {
      console.log('reload')
      location.reload()
    }
    $('.layout-sidebar').show()
    $('.layout-topbar').show()
    // console.log('abyc', this.$store.getters)
    var that = this
    setTimeout(function () {
    that.$router.push({path: '/'})
    }, 3000);
  },
}
</script>
